import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "../BaseTextBoxEditor";
import { IPostCodeAnywhereSearchSpecificProps, PostCodeAnywhereSearch } from "./PostCodeAnywhereSearch";
import * as React from "react";

export interface IPostCodeAnywhereSearchEditorProps
    extends IBaseTextBoxEditorProps,
        IPostCodeAnywhereSearchSpecificProps,
        React.Props<PostCodeAnywhereSearchEditor> {}

export class PostCodeAnywhereSearchEditor extends BaseTextBoxEditor<IPostCodeAnywhereSearchEditorProps> {
    constructor(props: IPostCodeAnywhereSearchEditorProps) {
        super(props);
    }

    protected getInput() {
        return <PostCodeAnywhereSearch {...(this.props as any)} id={this.state.inputGroupId} />;
    }
}
